import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {intlShape, FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import _ from 'lodash';

const LOCALE_PREFIX = 'DE/pages/SepaPage/SepaPage';

export class Agreement extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        agreeDate: PropTypes.string.isRequired,
        agreeCity: PropTypes.string.isRequired,
        agreeCountry: PropTypes.string.isRequired,
    };

    render() {
        const { agreeDate, agreeCity, agreeCountry } = this.props;
        return (
            <div className="agreement">
                <p>
                    {agreeDate}, {agreeCity}, <FormattedMessage id={`${LOCALE_PREFIX}.countryList.${agreeCountry}`} />
                </p>

            </div>

        );
    }
}

export const mapStateToProps = state => ({
    agreeDate: _.get(state, 'serverData.decisionModel.agreementDateFormat.agreeDate'),
    agreeCity: _.get(state, 'serverData.decisionModel.agreementDateFormat.agreeCity'),
    agreeCountry: _.get(state, 'serverData.decisionModel.agreementDateFormat.agreeCountry')
});

export default connect(mapStateToProps)(injectIntl(Agreement));
